import React, { Component } from 'react';

export class Involved extends Component {

    componentWillReceiveProps(props) {
        const clearChildForm = this.props.clearChildFormCDSQ;

        if (props.clearChildFormCDSQ !== clearChildForm) {
            this.clearIncidentSpecific();
        }
    }

    handleInvolvedChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.props.specificChanges(name, value);
    }

    handleNameInvolvedChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.props.specificChanges(name, value);
    }

    showInvolvedText = () => {
        if (this.props.incidentObj.involvedPerson === '') return null;
        return <div className="col-sm-5">Please specify: <input className="form-control" type="text" name="involvedPersonSpecify" onBlur={this.handleNameInvolvedChange} placeholder="e.g. Bar Manager - Joe Smith" maxLength={100}/></div>;
    }

    render() {
        return (
            <div className="form-horizontal row spacer">
                <label className="control-label col-sm-4" htmlFor="Involved">Who were involved in the assault/fight?</label>
                <div className="col-sm-3">
                    <div className="form-horizontal">
                        <label>
                            <input className="form-check-input" type="radio" name="involvedPerson" value="employees" onChange={this.handleInvolvedChange} />
                            Employees
                        </label>
                    </div>
                    <div className="form-horizontal">
                        <label>
                            <input className="form-check-input" type="radio" name="involvedPerson" value="patrons" onChange={this.handleInvolvedChange} />
                            Patrons
                        </label>
                    </div>
                    <div className="form-horizontal">
                        <label>
                            <input className="form-check-input" type="radio" name="involvedPerson" value="both" onChange={this.handleInvolvedChange} />
                            Both
                        </label>
                    </div>
                </div>
                {this.showInvolvedText()}
            </div >
        );
    }
}

export default Involved;


// WEBPACK FOOTER //
// ./src/components/questions/Involved.jsx